import {css} from 'styled-components';

import type {StyledProps} from './types';

const base = css<StyledProps>`
  cursor: ${({disabled}) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const web = css<StyledProps>`
  box-sizing: border-box;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

  ${base};
`;

export const native = css<StyledProps>`
  ${base};
`;
